import { FC } from "react";

import { RideDelayStatusEnum } from "@ryde/shared";

import { LiveMapDelayStatusBadge } from "./live-map-delay-status-badge";

interface ILiveMapGroupHead {
  delayStatus: RideDelayStatusEnum;
}

export const LiveMapGroupingHead: FC<ILiveMapGroupHead> = ({ delayStatus }) => {
  return <LiveMapDelayStatusBadge status={delayStatus} />;
};
